import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { I18nService } from '../../../core/services/i18n.service';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { TransactionData } from '../../interfaces/transaction/transaction-data';
import { AmountCurrencyDisplayPipe } from '../../pipes/amount-currency-display.pipe';

@Injectable({
  providedIn: 'root'
})
export class TransactionHistoryToTableDataMapper {

  constructor(private i18n: I18nService,
              private amountCurrencyPipe: AmountCurrencyDisplayPipe) {
  }

  private dialogTableDataRows: DialogTableDataRow[] = [];

  reset() {
    this.dialogTableDataRows = [];
  }

  /**
   * recursive mapping
   * TODO implement hierarchical view (e.g. TreeTable)
   * @param transactionHistory
   * @param parentId = Id of the main transaction of the dialog
   */
  public map(transactionHistory: TransactionData[], parentId: string): DialogTableDataRow[] {
    transactionHistory.map(th => {
      this.dialogTableDataRows.push(
        {
          id: th.id,
          titleStyleClass: 'font-bold',
          title: formatDate(th.date, 'dd.MM.yyyy - HH:mm:ss', 'de'),
          value: this.i18n.i18nLng()[th.type] + ' | '
            + this.amountCurrencyPipe.transform(th.amount, th.currency, 100) + ' | '
            + th.id + ' | '
            + th?.statusInfo + ((th?.statusCode !== null && th?.statusCode !== undefined) ? ' (' + th?.statusCode + ')' : ''),
          selectable: th.id !== parentId,
        }
      );
      if (th!!.history && th.history.length > 0) {
        this.map(th.history, parentId);
      }
    });

    return this.dialogTableDataRows;
  }

}
